import { ChampionshipStageTab } from 'modules/championship/domain/enums/championship-stage-tab';
import { StageType } from 'modules/championship/domain/enums/stage-type';
import { StageV2 } from 'modules/championship/domain/interfaces/stage';

/**
 * Типы этапов, у которых есть «Сетка матчей».
 *
 * Сейчас это все пять значений `StageType`, то есть тип этапа ничего не
 * ограничивает — реальный гейт «Сетки» один: минимум две команды. Список
 * оставлен явным, потому что при добавлении нового типа этапа он должен
 * решаться осознанно, а не молча получить сетку.
 */
export const STAGE_TYPES_WITH_GRID: StageType[] = [
  StageType.SINGLE_ELIMINATION,
  StageType.DOUBLE_ELIMINATION,
  StageType.GROUP,
  StageType.ROUND_ROBIN_1,
  StageType.ROUND_ROBIN_2,
];

/**
 * Доступна ли подвкладка этапа.
 *
 * Читают двое: `TabMenu` — чтобы погасить недоступную вкладку, и роутер этапа —
 * чтобы увести с прямого адреса на корень этапа. Отсюда чистая функция в
 * `domain`, а не хук.
 *
 * Порядок проверок унаследован от прежнего `activeTabs` таб-бара этапа:
 * «Команды» доступны сразу, а «Сетка матчей» и «Календарь матчей» — только
 * начиная с двух команд. Подвкладка «Редактирование» доступна всегда,
 * поэтому её в `ChampionshipStageTab` нет.
 */
export const isStageTabAvailable = (stage: StageV2 | null | undefined, tab: ChampionshipStageTab): boolean => {
  if (!stage) {
    return false;
  }

  if (tab === ChampionshipStageTab.TEAMS) {
    return true;
  }

  if (stage.teams.length < 2) {
    return false;
  }

  if (tab === ChampionshipStageTab.MATCHES) {
    return true;
  }

  return STAGE_TYPES_WITH_GRID.includes(stage.type);
};
